import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import StatelessTags from "@/components/TagsMultiselect/StatelessTags.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormTags',
    props: {
        value: null,
        placeholder: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const valueArray = computed(() => props.value?.split(",").map((v) => v.trim()) ?? []);
        function onInput(tags) {
            emit("input", tags.join(","));
        }
        return { __sfc: true, props, emit, valueArray, onInput, StatelessTags };
    }
});
